import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Star } from "@faire/web--source/slate/icons/foundation/Star";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { AccessibleStarsDescription } from "@faire/web--source/ui/AccessibleStarsDescription";
import range from "lodash/range";
import React, { useId } from "react";
var getFontSize = function(iconSize) {
    if (iconSize === "compact" || iconSize === "small") {
        return "12px";
    } else if (iconSize === "large") {
        return "24px";
    } else {
        return "16px";
    }
};
export var RatingDisplay = function(props) {
    var linearGradientId = "partialStar-".concat(useId());
    var fontSize = getFontSize(props.size);
    var ratingOffset = "".concat(props.rating * 100 % 100, "%");
    var emptyColor = props.size === "compact" ? Core.text.subdued : Core.text.inverse;
    return /*#__PURE__*/ _jsx(AccessibleStarsDescription, {
        rating: props.rating,
        children: /*#__PURE__*/ _jsxs(Row, {
            children: [
                /*#__PURE__*/ _jsx("svg", {
                    style: {
                        width: 0,
                        height: 0,
                        visibility: "hidden"
                    },
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ _jsx("defs", {
                        children: /*#__PURE__*/ _jsxs("linearGradient", {
                            id: linearGradientId,
                            x1: "0%",
                            y1: "0%",
                            x2: "100%",
                            y2: "0%",
                            children: [
                                /*#__PURE__*/ _jsx("stop", {
                                    offset: "0%",
                                    style: {
                                        stopColor: Core.icon.default,
                                        stopOpacity: 1
                                    }
                                }),
                                /*#__PURE__*/ _jsx("stop", {
                                    offset: ratingOffset,
                                    style: {
                                        stopColor: Core.icon.default,
                                        stopOpacity: 1
                                    }
                                }),
                                /*#__PURE__*/ _jsx("stop", {
                                    offset: ratingOffset,
                                    style: {
                                        stopColor: emptyColor,
                                        stopOpacity: 1
                                    }
                                }),
                                /*#__PURE__*/ _jsx("stop", {
                                    offset: "100%",
                                    style: {
                                        stopColor: emptyColor,
                                        stopOpacity: 1
                                    }
                                })
                            ]
                        })
                    })
                }),
                range(1, 6).map(function(starValue, index) {
                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            index === 0 ? null : /*#__PURE__*/ _jsx(Spacer, {
                                width: props.size === "compact" ? 2 : 4
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                style: {
                                    display: "flex"
                                },
                                color: props.size === "compact" && starValue > props.rating ? emptyColor : Core.text.default,
                                children: /*#__PURE__*/ _jsx(Star, {
                                    fontSize: fontSize,
                                    fill: // eslint-disable-next-line no-nested-ternary
                                    starValue <= props.rating ? Core.icon.default : starValue < props.rating + 1 ? "url(#".concat(linearGradientId, ")") : emptyColor
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
